const SCHEME = "https://";
export const REGION = "asia-northeast1";
export const PROJECT_ID = process.env.REACT_APP_LANDIT_ADMIN_PROJECT_ID;
export const CLOUD_FUNCTIONS = `${SCHEME}${REGION}-${PROJECT_ID}.cloudfunctions.net`;
